export const API_URL = process.env.NEXT_PUBLIC_API_URL;

// export const API_URL = 'https://vital-educator.herokuapp.com';
// export const API_URL = 'https://localhost:5001';
// export const API_URL = 'https://api.vitaleducators.com';
